var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivites(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insights_black_24dp",
    transform: "translate(-0.381 0.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(0.381 -0.192)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 16,
    height: 16,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(0.791 2.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M15.134,8A1.416,1.416,0,0,0,13.77,9.774L11.262,12.29a1.439,1.439,0,0,0-.735,0l-1.8-1.8a1.413,1.413,0,1,0-2.728,0L2.774,13.7a1.412,1.412,0,1,0,1,1l3.216-3.223a1.439,1.439,0,0,0,.735,0l1.8,1.8a1.413,1.413,0,1,0,2.728,0l2.516-2.509A1.412,1.412,0,1,0,15.134,8Z",
    transform: "translate(-1 -4.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M14.12,7.24l.664-1.463L16.24,5.12l-1.456-.657L14.12,3l-.65,1.463L12,5.12l1.47.657Z",
    transform: "translate(-4.226 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M2.767,9.534,3.12,8.12l1.413-.353L3.12,7.413,2.767,6,2.413,7.413,1,7.767l1.413.353Z",
    transform: "translate(-1 -3.88)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivites);
export default __webpack_public_path__ + "static/media/activites.dae8480ce9a9101e8a65ddac01d4a24b.svg";
export { ForwardRef as ReactComponent };